import { defineTranslateKeys } from 'lib/tolgee'

const TOLGEE_KEYS = defineTranslateKeys({
  draft: {
    key: 'ChipStatus-draft',
    defaultValue: 'Rascunho',
  },
  done: {
    key: 'ChipStatus-done',
    defaultValue: 'Concluído',
  },
  zai: {
    key: 'ChipStatus-zai',
    defaultValue: 'Zai',
  },
  tooltipZai: {
    key: 'ChipStatus-tooltip-zai',
    defaultValue: 'Esse dashboard tem um report automático criado pela Zai, nossa AI',
  },
  tooltipDone: {
    key: 'ChipStatus-tooltip-done',
    defaultValue: 'Arquivo finalizado pronto para compartilhar com seu time',
  },
  tooltipDraft: {
    key: 'ChipStatus-tooltip-draft',
    defaultValue: 'Arquivo em modo de edição e ainda pode sofrer alterações',
  },
})

export default TOLGEE_KEYS
